import Maintenance from "Components/ui/MaintenancePage";
import React from "react";

const Dashboard = () => {
  document.title = "Papermap | Dashboard";

  // const [periodData, setPeriodData] = useState<any>([]);
  // const [periodType, setPeriodType] = useState<string>("Year");

  // const selectProperties = createSelector(
  //   (state: selectState) => state.dashboard,
  //   (dashboard) => ({
  //     chartsData: dashboard.dashboardChartData,
  //   })
  // );

  // const { chartsData } = useSelector(selectProperties);

  // useEffect(() => {
  //   setPeriodData(chartsData);
  // }, [chartsData]);

  // const onChangeChartPeriod = (pType: any) => {
  //   setPeriodType(pType);
  //   dispatch(onGetChartData(pType));
  // };

  // const dispatch = useDispatch<any>();
  // useEffect(() => {
  //   dispatch(onGetChartData("Year"));
  // }, [dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Maintenance title="Dashboard under development." />
      </div>
    </React.Fragment>
  );
};
export default Dashboard;
